import type { App } from "vue"
import type { ModuleOptions } from "@core/types/module"
import { modules } from "@modules/index"

/**
 * Charge tous les modules et appelle leurs hooks d'initialisation
 * @param app - Instance de l'application Vue
 * @param options - Options de chargement
 */
export async function loadModules(
    app: App,
    options: ModuleOptions
): Promise<void> {
    // On construit un tableau de Promises pour paralléliser le chargement
    await Promise.all(
        modules.map(async (module) => {
            if (!module || typeof module.install !== "function") {
                console.warn(
                    `[loadModules] Module "${module?.name || "unknown"}" n'exporte pas une fonction install()`
                )
                return
            }

            const moduleName = module.name || "unknown"

            try {
                await Promise.resolve(module.install(app, options))
                console.log(
                    `[loadModules] Module "${moduleName}" chargé avec succès`
                )
            } catch (error) {
                console.error(
                    `[loadModules] Erreur lors du chargement du module "${moduleName}":`,
                    error
                )
            }
        })
    )
}
